module.exports = __webpack_public_path__ + "static/media/Layout9.7ca66d83.png";